import graphql__9eec7169b70dd675858b from "./__generated__/ContactViewQuery.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import ContactHeader from "./ContactHeader";
import BreadcrumbNavigation from "./navigation/BreadcrumbNavigation";
import SecondaryNavigation from "./navigation/SecondaryNavigation";
import {loadQuery, usePreloadedQuery} from "react-relay/hooks";
import type {ContactViewQuery as ContactViewQueryType} from "./__generated__/ContactViewQuery.graphql";
import ContactViewQuery from "./__generated__/ContactViewQuery.graphql";
import {hideModal, showModal} from "../store/actions";
import {connect} from "react-redux";
import {Outlet} from "react-router";
import {useIntl} from "react-intl";

type ContactViewParams = {
    prepared: any
};

const connector = connect(undefined, {
    dispatchShowModal: showModal,
    dispatchHideModal: hideModal
});

type ContactViewProps = ContactViewParams;

const ContactView: React.FC<ContactViewProps> = (props) => {
    const intl = useIntl();

    const {contact} = usePreloadedQuery<ContactViewQueryType>(
        graphql__9eec7169b70dd675858b,
        props.prepared.contactViewQuery
    );
    if (contact == null) {
        return <p>Contact not found</p>;
    }

    const breadcrumbNavigationItems = [
        {label: intl.formatMessage({id: 'breadcrumb.contacts'}), to: '/contacts'},
        {label: contact.teamName ?? (contact.givenName + ' ' + contact.familyName), to: '/contacts/' + contact.id},
    ]
    const secondaryNavigationItems = [
        {
            label: intl.formatMessage({id: 'tab.contact'}),
            path: '/contacts/:id',
            to: '/contacts/' + contact.id + '/details',
            exact: true
        },
        {
            label: intl.formatMessage({id: 'tab.activities'}),
            to: '/contacts/' + contact.id + '/activities',
            exact: true
        },
        {
            label: intl.formatMessage({id: 'tab.dataProtection'}),
            to: '/contacts/' + contact.id + '/data-protection',
            exact: true
        },
        {
            label: intl.formatMessage({id: 'tab.marketing'}),
            to: '/contacts/' + contact.id + '/marketing',
            exact: true
        },
    ]

    return (
        <>
            <BreadcrumbNavigation items={breadcrumbNavigationItems}/>
            <ContactHeader contact={contact}/>
            <SecondaryNavigation items={secondaryNavigationItems}/>
            <div className="mx-auto lg:px-8 grid grid-cols-1 gap-x-4 gap-y-8">
                <Outlet context={contact} key={contact.id}/>
            </div>
        </>
    );
}

export default connector(ContactView);

function prepare_ContactView(params, relayEnvironment) {
    return {
        contactViewQuery: loadQuery(
            relayEnvironment,
            ContactViewQuery,
            {
                id: params.id,
            },
            {fetchPolicy: 'store-and-network'},
        ),
    }
}

export {prepare_ContactView};
